import { useParams } from '@fs/zion-router'
import { type PID } from '@fs/zion-tree-types'
import { pidRegexStr } from '@fs/zion-pid'
import { type PathParamMap } from '../utils/pathParamTypes'

export const RESEARCH_HELP_ROUTE_PATH = `/research-help/:pid(${pidRegexStr as PID})/:tab(dismissed)?` as const

type ResearchHelpParams = PathParamMap<typeof RESEARCH_HELP_ROUTE_PATH>

export const useResearchHelpParams = (): ResearchHelpParams => useParams<ResearchHelpParams>()
